import { makeAutoObservable } from "mobx"
import type { RootStore } from "./RootStore.js"

type ViewerState = { status: "closed" } | { status: "open"; index: number; mediaIds: string[] }

export class ViewerStore {
  state: ViewerState = { status: "closed" }
  pendingMediaId: string | null = null
  rootStore: RootStore

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this, { rootStore: false })
  }

  get isOpen(): boolean {
    return this.state.status === "open"
  }

  get currentIndex(): number {
    return this.state.status === "open" ? this.state.index : -1
  }

  get currentMediaId(): string | null {
    if (this.state.status !== "open") return null
    return this.state.mediaIds[this.state.index] ?? null
  }

  get total(): number {
    return this.state.status === "open" ? this.state.mediaIds.length : 0
  }

  open(mediaIds: string[], index: number): void {
    this.state = { status: "open", index, mediaIds }
  }

  close(): void {
    this.state = { status: "closed" }
  }

  next(): void {
    if (this.state.status !== "open") return
    if (this.state.index < this.state.mediaIds.length - 1) {
      this.state = { ...this.state, index: this.state.index + 1 }
    }
  }

  previous(): void {
    if (this.state.status !== "open") return
    if (this.state.index > 0) {
      this.state = { ...this.state, index: this.state.index - 1 }
    }
  }
}
